export const analyticsTracker = (analytics, localAnalyticsId, event) => {
  if (analytics) {
    const { id, description, callback } = analytics;
    if (analytics.localAnalyticsId) {
      localAnalyticsId = analytics.localAnalyticsId;
    }
    if (id && typeof callback === "function") {
      callback(
        typeof localAnalyticsId === "string" && localAnalyticsId !== "" ? `${id}.${localAnalyticsId}` : id,
        description || "",
        event
      );
    }
  }
};
